import { STORAGE_KEYS } from "@/libraries/constant";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SyncStoreState {
	memberSyncChatLastUnix: number;
	groupSyncLastUnix: number;
	caseSyncLastUnix: number;
	inboxSyncLastUnix: number;
}

interface SyncStoreAction {
	setMemberSyncChatLastUnix: (unix: number) => void;
	setGroupSyncLastUnix: (unix: number) => void;
	setCaseSyncLastUnix: (unix: number) => void;
	setInboxSyncLastUnix: (unix: number) => void;
	reset: () => void;
}

type SyncStore = SyncStoreState & SyncStoreAction;

const initialState: SyncStoreState = {
	memberSyncChatLastUnix: 0,
	groupSyncLastUnix: 0,
	caseSyncLastUnix: 0,
	inboxSyncLastUnix: 0,
};

export const useSyncStore = create<SyncStore>()(
	persist(
		(set) => ({
			...initialState,
			setMemberSyncChatLastUnix: (memberSyncChatLastUnix) =>
				set({ memberSyncChatLastUnix }),
			setGroupSyncLastUnix: (groupSyncLastUnix) => set({ groupSyncLastUnix }),
			setCaseSyncLastUnix: (caseSyncLastUnix) => set({ caseSyncLastUnix }),
			setInboxSyncLastUnix: (inboxSyncLastUnix) => set({ inboxSyncLastUnix }),
			reset: () => set(initialState),
		}),
		{
			name: STORAGE_KEYS.PERSIST_SYNC_STORAGE,
			version: 1,
		},
	),
);
